angular.module('app').config(clientsRouting);

function clientsRouting($routeProvider) {
  $routeProvider
    .when('/clients', {
      pageTitle: 'CLIENTS',
      template: '<clients-page></clients-page>',
      accessPermission: 'index_client_accountadmin',
      menu: 'contacts',
      authReq: true,
    })
    .when('/clients/new', {
      pageTitle: 'ADD_CLIENT',
      template: '<client-page></client-page>',
      breadcrumb: {
        label: 'CLIENTS',
        parent: 'clients',
        ajs: true,
      },
      accessPermission: 'create_client_accountadmin',
      menu: 'contacts',
      authReq: true,
    })
    .when('/clients/:id', {
      params: {
        mode: null,
      },
      pageTitle: 'EDIT_CLIENT',
      template: '<client-page></client-page>',
      breadcrumb: {
        label: 'CLIENTS',
        parent: 'clients',
        ajs: true,
      },
      accessPermission: 'show_client_accountadmin',
      menu: 'contacts',
      authReq: true,
    });
}

clientsRouting.$inject = ['$routeProvider'];
